import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    InputSignal,
    OnInit,
    signal,
    WritableSignal,
} from '@angular/core';

import { InvoiceDataService } from '../../invoice-data.service';
import { ProcessInstance } from '@lib/workflow-util';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import {
    IInvoiceProcessPreviewDialogData,
    InvoiceProcessPreviewDialogComponent,
} from './dialog/invoice-process-preview-dialog.component';
import { DialogOptions } from '@lib/util';

@Component({
    selector: 'invoice-process-status-indicator',
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './invoice-process-status-indicator.component.html',
    styleUrl: './invoice-process-status-indicator.component.scss',
})
export class InvoiceProcessStatusIndicatorComponent implements OnInit {
    processes: WritableSignal<ProcessInstance[]> = signal<ProcessInstance[]>([]);

    readonly invoiceId: InputSignal<string> = input.required();
    readonly invoiceNumber: InputSignal<string> = input.required();
    private readonly _dataService = inject(InvoiceDataService);
    private readonly _dialog: MatDialog = inject(MatDialog);

    ngOnInit(): void {
        this.getData();
    }

    public openProcessDialog(processInstance: ProcessInstance): void {
        const data: IInvoiceProcessPreviewDialogData = {
            processInstance,
            invoiceNumber: this.invoiceNumber(),
        };

        const options = DialogOptions.LARGE(data);
        options.height = '90vh';
        this._dialog.open(InvoiceProcessPreviewDialogComponent, options);
    }

    private getData(): void {
        this._dataService.getOpenProcessesForInvoice(this.invoiceId()).subscribe((instances: ProcessInstance[]) => {
            this.processes.set(instances);
        });
    }
}
